import { createUseStyles } from 'react-jss';

var useStyles = createUseStyles({
  '@global': {
    '#credential_picker_container': {
      top: '100px !important'
    },
    'input::-ms-reveal, input::-ms-clear': {
      display: 'none'
    }
  }
}, {
  name: 'one-tap'
});

export { useStyles as u };
//# sourceMappingURL=styles-59499c92.js.map
